<template>
  <div>
    <Loader v-if="loader" />

    <div class="flex justify-content-between mb-3">
      <div class="flex align-items-center text-sm">
        Elementi: {{selectedSuggests.length}} selezionati su {{fatture.length}}
      </div>
      <div class="flex flex-row flex-wrap">
        <div class="flex align-items-center mr-3">
          <Checkbox v-model="isConsiderNegative" :binary="true" />
          <label class="ml-2"> Considera negativi </label>
        </div>
        <div>
          <Button icon="pi pi-download" iconPos="right" label="Esporta" @click="exportCSV($event)" class="p-button-outlined p-button-secondary p-button-sm ml-auto mr-2" />
        </div>
        <div>
          <Button @click="listImportDialog = true" class="p-button-outlined p-button-sm mr-2" label="Importa lista" />
        </div>
        <div>
          <Button icon="pi pi-pencil" class="p-button-outlined p-button-sm" label="Importa e modifica"  @click="importaModificaDialog = true" />
        </div>
      </div>
    </div>

    <InputText  type="text"  @keyup.enter="search($event)" v-model="searchString" class="inputfield w-full" placeholder="Ricerca..." />
                
      <div v-if="fatture.length > 0">
        <DataTable ref="dt" :value="fatture" responsiveLayout="scroll" v-model:selection="selectedSuggests" @row-unselect="deselectedSuggest($event)" scrollHeight="400px">
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column field="label" header="Info"></Column>
            <Column field="saldo_modificato" header="Saldo">
              <template #body="{data}">
                  <p :class="data.saldo_modificato.toFixed(2) != 0 ? 'p-error' : ''">
                    {{data.saldo_modificato.toFixed(2)}}
                  </p>      
              </template>
            </Column>
            <Column field="pagato" header="Pagato">
              <template #body="{data}">
                  {{data.pagato.toFixed(2)}}
              </template>
            </Column>
            <Column field="totale" header="Totale fattura">
              <template #body="{data}">
                  {{data.totale.toFixed(2)}}
              </template>
            </Column>
            <Column field="modified" header="Modificato">
              <template #body="{data}">
                <small v-if="data.modified" @click="resetSaldo(data)" class="p-error p-reset"> Ripristina </small>
              </template>
            </Column>
        </DataTable>

        <div class="chip-selected-suggest mt-3 p-fluid">
          <Chips v-model="selectedSuggests" @keypress.prevent="false" @remove="removeChip($event)"> 
            <template #chip="slotProps">
                <div @click="openEditSaldoDialog(slotProps.value)" class="chip-basic">
                    <div class="title-chip">{{slotProps.value.label.split('-')[0]}}</div>
                    <span style="font-size: 12px">€ {{slotProps.value.saldo_modificato.toFixed(2)}}</span>
                    <i  class="icon-edit-saldo pi pi-pencil ml-2" style="font-size: 10px"></i>
                </div>
            </template>
          </Chips>
        </div>

          <div class="my-2 md:mt-0 flex align-items-center">
            <div class="surface-300 border-round overflow-hidden w-full  mt-1" style="height:5px">
              <div 
              class="p-bar h-full" 
              :style="{ width: percentage +'%'}"
              :class="(percentage == 100) ? 'bg-blue-500' : (percentage > 100) ? 'bg-red-500': 'bg-yellow-500'"
              >
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-4 flex justify-content-start">
              <div class="text-left">
                <p class="title-bar">ASSOCIATO</p>
                <b  class="num-bar text-yellow-500">{{associatedSum.toFixed(2)}}</b>
              </div>
            </div>
            <div class="col-4 flex justify-content-center">
              <div class="text-left">
                <p class="title-bar">RIMANENTI</p>
                <!-- <b class="num-bar p-error">{{ isConsiderNegative ? (Math.abs(Math.abs(estrattoConto.value) - associatedSum)).toFixed(2) : (estrattoConto.value - associatedSum).toFixed(2)}}</b> -->
                <b class="num-bar p-error">{{ (Math.abs(Math.abs(estrattoConto.value) - Math.abs(associatedSum))).toFixed(2) }}</b>
              </div>
            </div>
            <div class="col-4 flex justify-content-end">
              <div class="text-left">
                <p class="title-bar">TOTALE</p>
                <b class="num-bar text-blue-500">{{estrattoConto.value.toFixed(2)}} </b> &euro;
              </div>
            </div>
          </div> 

        <div class="mt-3 text-right">
            <Button 
            @click="associa" 
            label="Associa movimento" 
            class="p-button-outlined" 
            :disabled="Math.abs(associatedSum.toFixed(2)) != Math.abs(estrattoConto.value.toFixed(2)) || tempDisable" 
            :class="Math.abs(associatedSum.toFixed(2)) != Math.abs(estrattoConto.value.toFixed(2)) ? 'p-button-secondary' : ' p-button-primary'" 
            />
        </div>
      </div>

      <div v-if="invoiceFromDescription.length > 0" class="mt-4">
        Suggerimento: 
          <span v-for="invoice in invoiceFromDescription" :key="invoice" class="invoice-desc mr-2"  @click="injectSuggest(invoice)">
          {{invoice}}
          </span>  
          <span v-if="invoiceFromDescription.length > 1" class="invoice-desc btn-add" @click="addAllinvoiceFromDescription">
            AGGIUNGI TUTTO
          </span> 
      </div>

  </div>

   <!-- DIALOG EDIT SALDO CHIP -->
    <Dialog v-model:visible="editSaldoDialog" :style="{width: '450px'}" header="Modifica" :modal="true">
        <div class="confirmation-content">
            <div v-if="estrattoConto">Inserisci l'importo <br>
            <InputText type="text" v-model="temp.saldo_modificato" class="inputfield w-full mt-2" :class="{'p-invalid': validationErrors.saldo && submitted }" />
             <small class="p-error" v-if="validationErrors.saldo && submitted">Non puoi inserire un valore maggiore o uguale al saldo</small>
            </div>
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="editSaldoDialog = false"/>
            <Button label="Modifica" icon="pi pi-check" class="p-button-text" @click="editSaldo" />
        </template>
    </Dialog>


    <!-- DIALOG IMPORT LIST FROM FILE OR COPY -->
    <Dialog v-model:visible="listImportDialog" :style="{width: '80%'}" header="Importa Lista" :modal="true">
        <div class="confirmation-content" style="min-height:400px">
          <div class="formgrid grid form-file">
            <div class="field col-3">
              <label>File</label>
              <div class="button-wrapper">
                <span :class="['label', {'active': fileToUpload.length > 0}]">
                  {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
                </span>
                <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
              </div>
              <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
              <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
              <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
            </div>
            <div class="field col-3">
              <label>Indice Foglio (inizia da zero)</label>
              <InputNumber v-model="selectedIndexFile" :useGrouping="false" class="inputfield w-full uppercase" />
              <div v-show="validationErrors.indexFile && submitted" class="p-error">Campo richiesto.</div>
            </div>
            <div class="field col-3">
              <label>Righe occupate dalla testata</label>
              <InputNumber v-model="selectedRowHeaderFile" :useGrouping="false" class="inputfield w-full uppercase" />
              <div v-show="validationErrors.rowHeaderFile && submitted" class="p-error">Campo richiesto.</div>
            </div>
            <div class="field col-3">
              <label>Colonna (A,B,C...)</label>
              <InputText type="text" v-model="selectedColumnFile" class="inputfield w-full uppercase" />
              <div v-show="validationErrors.columnFile && submitted" class="p-error">Campo richiesto.</div>
            </div>
            <div class="col-12 my-4">
              <Divider align="center">
                <span>oppure</span>
              </Divider>
            </div>
            <div class="col-12">
              <Textarea v-model="copyAndPasteList" :autoResize="true" rows="20" style="width:100%" placeholder="Incolla qui la lista..." />
            </div>
          </div>
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="listImportDialog = false"/>
            <Button label="Importa" icon="pi pi-check" class="p-button-text" @click="importListToInput" />
        </template>
    </Dialog>

    <Dialog
      v-model:visible="importaModificaDialog"
      :style="{ width: '80%' }"
      header="Importa e modifica"
      :modal="true"
      :closable="false"
    >
      <div class="p-fluid">
        <div class="p-field">
          <label for="xlsxFile">File Excel (.xlsx)</label>

          <FileUpload
            id="xlsxFile"
            name="file"
            mode="basic"
            chooseLabel="Scegli file"
            :auto="false"
            :customUpload="true"
            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :maxFileSize="20000000"
            :multiple="false"
            @select="onXlsxSelect"
            @clear="onXlsxClear"
          />

          <small class="p-text-secondary">
            Carica un solo file .xlsx
          </small>
        </div>
      </div>

      <template #footer>
        <Button
          label="Annulla"
          icon="pi pi-times"
          class="p-button-text"
          @click="importaModificaDialog = false"
        />

        <Button
          label="Conferma"
          icon="pi pi-check"
          :disabled="!xlsxFile"
          @click="onConfermaImportaModifica"
        />
      </template>
    </Dialog>
    
</template>

<script>
import { ref, getCurrentInstance, watch, computed, onMounted } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";
var XLSX = require("xlsx");

export default {
  emits:['movement-regularized'],
  components: {
    Loader
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  setup(props, {emit}) {
    
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const toast = useToast();
    const loader = ref(false)
    const dt = ref();
    const estrattoConto = ref(props.detail)
    const fatture = ref({})
    const selectedAssociate = ref(props.type)
    const searchString = ref('')
    const modified = ref([])
    const selectedSuggests = ref([])
    const submitted = ref(false);
    const validationErrors = ref({})
    const temp = ref(null)
    const editSaldoDialog = ref(false)
    const listImportDialog = ref(false)
    const tempDisable = ref(false)
    const invoiceFromDescription = ref([])
    const copyAndPasteList = ref('')
    const fileToUpload = ref([])
    const selectedColumnFile = ref('A')
    const selectedIndexFile = ref(0)
    const selectedRowHeaderFile = ref(1)
    const isConsiderNegative = ref(false)
    const allowedType = {
      'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
    const importaModificaDialog = ref(false)
    const xlsxFile = ref(null);

    onMounted(()=>{
      scrapeInvoiceFromDescription ()
    })

   
    const scrapeInvoiceFromDescription = () => {

      const regexLet = /([eE/gG][0-9]{7,8})/g;
      const regexNum = /([0-9]{7,8})/g;
      const str = estrattoConto.value.descrizione;
      let m;
      while ((m = regexLet.exec(str)) !== null) {
        if(!invoiceFromDescription.value.includes(m[0])){
          invoiceFromDescription.value.push(m[0])
        }
      }
      if(invoiceFromDescription.value.length == 0){
        while ((m = regexNum.exec(str)) !== null) {
          if(!invoiceFromDescription.value.includes(m[0])){
            invoiceFromDescription.value.push(m[0])
          }
        }
      }
    }

    const injectSuggest = (invoice) => {
      searchString.value = invoice
      search()
    }

    const addAllinvoiceFromDescription = () => {
      searchString.value = invoiceFromDescription.value.join(',');
      search()
    }

    const search = () => {
      
        if (selectedAssociate.value != '') {
          loader.value = true
          service.getSuggerimenti(selectedAssociate.value, searchString.value).then((res) => {
            if (res.items.length > 0) {
                const response = res.items.map((el) =>{
                  el.modified = false
                  el.saldo_modificato = el.saldo 
                  return el
                })
                verifyIsModified(response)
            } 
          }).finally(()=>{
            loader.value = false
          })
        }
      }

      //replace duplicate fattura if same element is already modified
      const verifyIsModified = (response) => {
        fatture.value = response.map((el) => {
          const index = modified.value.findIndex( (m) => m.numero === el.numero )
          if( index != -1 ){
            return modified.value[index]
          }
          return el
        });
      }

      const deselectedSuggest = (evt) => {
        if (evt.data.modified) {
          evt.data.saldo_modificato = evt.data.saldo
          evt.data.modified = false
        }
      }

      const removeChip = (evt) => {
        const item = evt.value[0]
        if (item.modified) {
          item.saldo_modificato = item.saldo
          item.modified = false
        }
      }


      const associa = () => {
        if (Math.abs(associatedSum.value).toFixed(2) == Math.abs(estrattoConto.value.value).toFixed(2)) {
          tempDisable.value = true
          const obj = estrattoConto.value
          obj.payments = selectedSuggests.value

          service.associateToPayments(obj).then((res)=> {
            if (res) {
              emit('movement-regularized',{id: estrattoConto.value.id})
            }
          }).finally(() =>{
            tempDisable.value = false
          })
        } 
      }

      const openEditSaldoDialog = (el) => {
        submitted.value = false;
        temp.value = null
        temp.value = {...el}
        editSaldoDialog.value = true
      }

      const editSaldo = () => {
        submitted.value = true;
        temp.value.saldo_modificato = temp.value.saldo_modificato.toString()
        temp.value.saldo_modificato = temp.value.saldo_modificato.replaceAll(',','.')
        temp.value.saldo_modificato = parseFloat(temp.value.saldo_modificato)
        
        selectedSuggests.value = selectedSuggests.value.filter(el => {
          if (el.numero == temp.value.numero) {
            el.saldo_modificato = temp.value.saldo_modificato
            el.modified = true
            editSaldoDialog.value = false
            return el
          } else {
            return el
          }
        })    
      }

      watch(selectedSuggests, () => {
        modified.value = selectedSuggests.value.filter(el => el.modified == true)
      })

      
      const percentage = computed(() => {
        return ((100 * Math.abs(associatedSum.value)) / Math.abs(estrattoConto.value.value)).toFixed(2)
      })
      
      const resetSaldo = (el) => {
        el.saldo_modificato =  el.saldo
        el.modified = false
      }


      
      const associatedSum = computed(() => {
        if (isConsiderNegative.value) {
          return selectedSuggests.value.reduce((old, el) =>  old +  el.saldo_modificato, 0)
        } else {
          return selectedSuggests.value.reduce((old, el) =>  Math.abs(old) +  Math.abs(el.saldo_modificato), 0)
        }
      })


      const handleFileUpload = async (evt) => {
        fileToUpload.value = []
        evt.preventDefault()
        submitted.value = false;
        fileToUpload.value = self.refs.file.files
      }
      
      const importListToInput = async ()  => {

        if (fileToUpload.value.length > 0) {
          if (selectedColumnFile.value > '' && selectedColumnFile.value.match(/^[a-zA-Z]+$/)) {
              selectedColumnFile.value = selectedColumnFile.value.toUpperCase()
              const data = await fileToUpload.value[0].arrayBuffer();
              const workbook = XLSX.read(data);
              let first_sheet_name = workbook.SheetNames[selectedIndexFile.value];
              let ws_rows = workbook.Sheets[first_sheet_name];

              if (`${selectedColumnFile.value}${selectedRowHeaderFile.value+1}` in ws_rows) {
                let vals = []
                for (const [key, el] of Object.entries(ws_rows)) {
                  if (key.startsWith(selectedColumnFile.value) && key > `${selectedColumnFile.value}${selectedRowHeaderFile.value}`) {
                    vals.push(el.v)
                  } 
                }
                // if (vals.length > 0) {
                searchString.value = vals.join(',');
                listImportDialog.value = false
                // }
                
              } else {
                toast.add({severity:'warn', summary: 'Errore Colonna File', detail: `La colonna ${selectedColumnFile.value} non esiste nel file o non ha valori`});
              }
          } else {
            toast.add({severity:'warn', summary: 'Errore Colonna File', detail: `La colonna ${selectedColumnFile.value} non è un valore consentito`});
          }
        } else {
          // console.log('copiaeincolla_lista');
          let arrList = copyAndPasteList.value.split(/\r?\n/);
          searchString.value = arrList.join();
          listImportDialog.value = false
        }

      }

      const exportCSV = () => {
        dt.value.exportCSV();
      };

    const onXlsxSelect = (event) => {
      xlsxFile.value = event.files?.[0] ?? null;
    };

    const onXlsxClear = () => {
      xlsxFile.value = null;
    };

    const onConfermaImportaModifica = async () => {
      if (!xlsxFile.value) {
        return;
      }

      const parseSaldo = (raw) => {
        if (raw === null || raw === undefined) {
          return null;
        }

        if (typeof raw === 'number') {
          return raw;
        }

        let s = String(raw).trim();
        if (s === '') {
          return null;
        }

        // Formato IT: 1.234,56
        if (s.includes(',')) {
          s = s.replace(/\./g, '').replace(',', '.');
        }

        const n = parseFloat(s);
        return Number.isNaN(n) ? null : n;
      };

      const data = await xlsxFile.value.arrayBuffer();
      const workbook = XLSX.read(data);

      const first_sheet_name = workbook.SheetNames[0];
      const ws_rows = workbook.Sheets[first_sheet_name];

      // FIX: l'utente di solito seleziona la riga come la vede in Excel (1-based)
      // quindi la converto in 0-based.
      const headerRow = Math.max(0, Number(selectedRowHeaderFile.value) - 1);

      const colNumero = 'A';
      const colSaldo = 'G';

      // controllo base: almeno una cella valorizzata in colonna A sulla riga header
      if (!(`${colNumero}${headerRow + 1}` in ws_rows)) {
        toast.add({
          severity: 'warn',
          summary: 'Errore File',
          detail: `La colonna ${colNumero} non esiste nel file o non ha valori`,
        });
        return;
      }

      // Mappa di appoggio per riga (per accoppiare A e G della stessa riga)
      const rowMap = {};

      for (const [key, cell] of Object.entries(ws_rows)) {
        if (key.startsWith('!')) {
          continue;
        }

        const m = key.match(/^([A-Z]+)(\d+)$/);
        if (!m) {
          continue;
        }

        const col = m[1];
        const row1Based = parseInt(m[2], 10);
        const row0Based = row1Based - 1;

        // solo righe dati, dopo header
        if (row0Based <= headerRow) {
          continue;
        }

        // prendo solo A e G
        if (col !== colNumero && col !== colSaldo) {
          continue;
        }

        if (!rowMap[row0Based]) {
          rowMap[row0Based] = {};
        }

        if (col === colNumero) {
          // Preferisco il valore "visualizzato" (cell.w) per non perdere zeri iniziali
          const numero = cell?.w !== undefined ? String(cell.w).trim() : String(cell?.v ?? '').trim();
          if (numero !== '') {
            rowMap[row0Based].numero = numero;
          }
        }

        if (col === colSaldo) {
          const saldo = parseSaldo(cell?.v);
          if (saldo !== null) {
            rowMap[row0Based].saldo = saldo;
          }
        }
      }

      // Mappa finale: numero fattura -> saldo dal file
      const saldoByNumero = new Map();
      for (const row of Object.values(rowMap)) {
        if (row.numero && row.saldo !== undefined) {
          saldoByNumero.set(row.numero, row.saldo);
        }
      }

      loader.value = true;

      try {
        const numeri = Array.from(saldoByNumero.keys()).join(',');
        const res = await service.getFattureVendita(numeri);

        if (Array.isArray(res.items) && res.items.length > 0) {
          const response = res.items.map((el) => {
            const numero = String(el.numero ?? '').trim();
            const saldoFile = saldoByNumero.get(numero);

            if (saldoFile === undefined) {
              el.modified = false;
              el.saldo_modificato = el.saldo;
              return el;
            }

            const same = Math.abs(Number(el.saldo) - Number(saldoFile)) < 0.00001;

            if (same) {
              el.modified = false;
              el.saldo_modificato = el.saldo;
            } else {
              el.modified = true;
              el.saldo_modificato = saldoFile;
            }

            return el;
          });

          verifyIsModified(response);
        }
      } finally {
        loader.value = false;
        importaModificaDialog.value = false;
        xlsxFile.value = null;
      }
    };

    const parseSaldo = (raw) => {
      if (raw === null || raw === undefined) {
        return null;
      }

      // Se è già numero (tipico di XLSX), non toccarlo
      if (typeof raw === 'number') {
        return raw;
      }

      let s = String(raw).trim();
      if (s === '') {
        return null;
      }

      // Se contiene la virgola, assumo formato IT: 1.234,56
      if (s.includes(',')) {
        s = s.replace(/\./g, '').replace(',', '.');
        const n = parseFloat(s);
        return Number.isNaN(n) ? null : n;
      }

      // Altrimenti assume formato standard: 1234.56 (non rimuovere i punti)
      const n = parseFloat(s);
      return Number.isNaN(n) ? null : n;
    };

    return {
        dt, estrattoConto, validationErrors, submitted, selectedAssociate,
        fatture, search, searchString, selectedSuggests, associa, addAllinvoiceFromDescription,
        associatedSum, openEditSaldoDialog, editSaldoDialog, editSaldo, temp, resetSaldo, tempDisable,
        deselectedSuggest, removeChip, percentage, loader, invoiceFromDescription, injectSuggest, 
        listImportDialog, importListToInput, fileToUpload, allowedType, selectedColumnFile, copyAndPasteList,
        selectedIndexFile, selectedRowHeaderFile, handleFileUpload, exportCSV, isConsiderNegative, importaModificaDialog,
        onXlsxSelect, onXlsxClear, onConfermaImportaModifica, xlsxFile, parseSaldo
    }
  },
}
</script>

<style scoped>
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.invoice-desc {
  cursor: pointer;
  background-color: var(--blue-100);
  padding: 6px 12px;
  border-radius: 5px;
  color: #2197f4;
}

.btn-add {
  font-size: 12px;
  background-color: var(--green-400) !important;
  color: #fff;
}
</style>
